import { useState, useEffect } from "react";

interface UseImageLoaderResult {
    loading: boolean;
    photo: string;
}
const loadingGif = `${window.location.origin}/image/icon_loader.gif`;

const useImageLoader = (url: string): UseImageLoaderResult => {
    const [src, setSrc] = useState(loadingGif);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let isMounted = true; // マウント状態を追跡
        
        // URL が空または undefined の場合は何もしない
        if (!url) {
            if (isMounted) {
                setLoading(false);
                setSrc(loadingGif);
            }
            return;
        }
        
        setLoading(true);
        const img = new Image();
        
        const handleLoad = () => {
            if (isMounted) { // マウントされている場合のみ状態更新
                console.log(`[useImageLoader] Image loaded successfully: ${url}`);
                setLoading(false);
                setSrc(url);
            } else {
                console.warn(`[useImageLoader] Attempted to update state after unmount for: ${url}`);
            }
        };
        
        const handleError = () => {
            if (isMounted) { // エラー時もマウント状態をチェック
                console.error(`[useImageLoader] Failed to load image: ${url}`);
                setLoading(false);
                setSrc(loadingGif); // エラー時はloadingGifを表示
            } else {
                console.warn(`[useImageLoader] Error handler called after unmount for: ${url}`);
            }
        };
        
        // イベントハンドラを設定する前に、既存のハンドラをクリア
        img.onload = null;
        img.onerror = null;
        
        // 新しいハンドラを設定
        img.onload = handleLoad;
        img.onerror = handleError;
        
        // 画像の読み込みを開始
        img.src = url;
        
        // クリーンアップ関数
        return () => {
            console.log(`[useImageLoader] Cleanup called for: ${url}`);
            isMounted = false; // アンマウント時にフラグを false に
            
            // イベントハンドラを即座にクリア
            img.onload = null;
            img.onerror = null;
            
            // 画像の読み込みをキャンセル
            if (img.src) {
                img.src = '';
            }
        };
    }, [url]);

    let photo = loading ? loadingGif : src;
    return {loading, photo};
}

export default useImageLoader;
